import classnames from "classnames";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { isBrowser } from "Shared/device-type";
import styles from "./tooltip.scss";
const ToolTip = ({ text, header, direction, persistent, small, children, carbonCloud, className, disableAdjust }) => {
    const [active, setActive] = useState(false);
    const [alwaysActive, setAlwaysActive] = useState(false);
    const [toolTipDirection, setToolTipDirection] = useState(direction);
    const ref = useRef(null);
    const tooltipRef = useRef(null);
    const tooltipId = useRef(`tooltip-${Math.random().toString(36).slice(2, 9)}`).current;
    const isVisible = active || alwaysActive;
    const handleClick = () => {
        !!persistent && setAlwaysActive(true);
    };
    const getToolTipDirection = (direction) => {
        if (direction === "top")
            return styles.top;
        if (direction === "left")
            return styles.left;
        if (direction === "bottom")
            return styles.bottom;
        if (direction === "right")
            return styles.right;
        if (direction === "custom")
            return styles.custom;
    };
    const adjust = useCallback(() => {
        if (!isBrowser() || !ref.current || !tooltipRef.current || disableAdjust) {
            return;
        }
        const elRect = ref.current.getBoundingClientRect();
        const bodyRect = document.body.getBoundingClientRect();
        const tooltipRect = tooltipRef.current.getBoundingClientRect();
        if (elRect.right + 150 > bodyRect.right) {
            setToolTipDirection("left");
        }
        else if (elRect.left - 250 < bodyRect.left) {
            setToolTipDirection("right");
        }
        else if (elRect.top - tooltipRect.height - 250 < 0) {
            setToolTipDirection("bottom");
        }
        else {
            setToolTipDirection("top");
        }
    }, [disableAdjust]);
    const showToolTip = useCallback(() => {
        if (isVisible)
            return;
        setActive(true);
        !!!persistent && adjust();
    }, [adjust, isVisible, persistent]);
    const hideToolTip = useCallback(() => {
        if (!active)
            return;
        setActive(false);
    }, [active]);
    const handleClickOutside = useCallback((e) => {
        const el = ref.current;
        if (!el || el.contains(e.target)) {
            return;
        }
        hideToolTip();
        setAlwaysActive(!!persistent);
    }, [hideToolTip, persistent]);
    const handleKeyDown = useCallback((e) => {
        if (e.key !== "Escape") {
            return;
        }
        setActive(false);
        setAlwaysActive(false);
    }, []);
    const getWidth = (text) => {
        return (text.length * 3.25) + 'px';
    };
    useEffect(() => {
        setAlwaysActive(!!persistent);
        !!!persistent && adjust();
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [adjust, handleClickOutside, persistent]);
    return (React.createElement("div", { ref: ref, tabIndex: 0, "aria-describedby": isVisible ? tooltipId : undefined, onMouseEnter: showToolTip, onMouseLeave: hideToolTip, onClick: handleClick, onFocus: showToolTip, onBlur: hideToolTip, onKeyDown: handleKeyDown, className: styles.TooltipWrapper },
        children,
        React.createElement("div", { id: tooltipId, role: "tooltip", "aria-hidden": !isVisible, ref: tooltipRef, "data-type": "tooltip", style: { width: getWidth(text) }, className: classnames(styles.Tooltip, !!small && styles.small, getToolTipDirection(toolTipDirection) || styles.top, !!carbonCloud && styles.carbonCloud, className, !isVisible && styles.hidden) },
            !!header && React.createElement("strong", null, header),
            React.createElement("div", null, text))));
};
export default ToolTip;
